import script from "./ClientsList.vue?vue&type=script&setup=true&lang=js"
export * from "./ClientsList.vue?vue&type=script&setup=true&lang=js"

import "./ClientsList.vue?vue&type=style&index=0&id=6a9e1114&lang=scss"

const __exports__ = script;

export default __exports__